module.exports = __webpack_public_path__ + "img/Armando-Campos.27e36eb6.png";